import styles from "./ImagePreviewAddOn.module.css";
import FixaImage from "@coworker/apprestructured/src/shared/wrappers/FixaImage/FixaImage";
import FixaSSRIcon from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import FurnitureSetIconPath from "@ingka/ssr-icon/paths/furniture-set";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import {
  isLoading,
  Loading,
} from "@coworker/apprestructured/src/task-management/loading";
import { FixaSkeleton } from "@coworker/apprestructured/src/shared/wrappers/FixaSkeleton/FixaSkeleton";

type ImagePreviewItem =
  | string
  | {
      src?: string;
      isLocalCombination?: boolean;
    };

type ImagePreviewAddOnProps = {
  srcs: ImagePreviewItem[] | Loading;
};

function ImagePreviewAddOn({ srcs }: ImagePreviewAddOnProps) {
  return (
    <div className={styles["imagePreviewContainer"]}>
      {isLoading(srcs) ? (
        <>
          <FixaSkeleton width="50px" height="50px" />
          <FixaSkeleton width="50px" height="50px" />
          <FixaSkeleton width="50px" height="50px" />
        </>
      ) : (
        srcs.slice(0, 3).map((item, i) => {
          const isLocalCombination =
            typeof item === "object" && item.isLocalCombination;
          const src = typeof item === "string" ? item : item.src;

          if (isLocalCombination) {
            return (
              <div
                className={styles["localCombinationImage"]}
                key={i}
                data-testid="local-combination-image-preview"
              >
                <FixaSSRIcon paths={FurnitureSetIconPath} />
              </div>
            );
          }

          return <FixaImage className={styles["image"]!} key={i} src={src} />;
        })
      )}
      {!isLoading(srcs) && srcs.length > 3 && (
        <FixaText className={styles["moreImages"]}>+{srcs.length - 3}</FixaText>
      )}
    </div>
  );
}

export default ImagePreviewAddOn;
